angular.module('impactx.smartform').controller('SmartFormTitleCtrl', [
    '$scope',
    'TranslationService',
    SmartFormTitleController]);

function SmartFormTitleController($scope, TranslationService) {
    $scope.trns = {
        required: TranslationService.get("required")
    }
}